module.exports = __webpack_public_path__ + "img/des_guzheng_4.dbd20b6e.jpg";